var _g, _g2, _g3, _g4, _g5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheck4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "check4",
    xmlns: "http://www.w3.org/2000/svg",
    width: 64.115,
    height: 34,
    viewBox: "0 0 64.115 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56509",
    "data-name": "\\uADF8\\uB8F9 56509",
    transform: "translate(11.047 28.106)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56508",
    "data-name": "\\uADF8\\uB8F9 56508",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33954",
    "data-name": "\\uD328\\uC2A4 33954",
    d: "M89.162,344.692h-.01a.944.944,0,1,0,.01,0Z",
    transform: "translate(-88.218 -344.692)",
    fill: "#fff"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56511",
    "data-name": "\\uADF8\\uB8F9 56511",
    transform: "translate(19.078 28.106)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56510",
    "data-name": "\\uADF8\\uB8F9 56510",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33955",
    "data-name": "\\uD328\\uC2A4 33955",
    d: "M153.291,344.692h-.01a.944.944,0,1,0,.01,0Z",
    transform: "translate(-152.347 -344.692)",
    fill: "#fff"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56513",
    "data-name": "\\uADF8\\uB8F9 56513",
    transform: "translate(52.204 28.106)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56512",
    "data-name": "\\uADF8\\uB8F9 56512",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33956",
    "data-name": "\\uD328\\uC2A4 33956",
    d: "M417.823,344.692h-.01a.944.944,0,1,0,.01,0Z",
    transform: "translate(-416.879 -344.692)",
    fill: "#fff"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56515",
    "data-name": "\\uADF8\\uB8F9 56515",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56514",
    "data-name": "\\uADF8\\uB8F9 56514"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33957",
    "data-name": "\\uD328\\uC2A4 33957",
    d: "M63.252,137l-1.263-1.263L59.446,128.1a.939.939,0,0,0-.285-1.834h-9.1v-4.08a1.945,1.945,0,0,0-1.943-1.943H1.943A1.945,1.945,0,0,0,0,122.188v22.084a1.945,1.945,0,0,0,1.943,1.943H3.011v2.072a1.945,1.945,0,0,0,1.943,1.943H7.117A4.951,4.951,0,0,0,16,152.188a4.951,4.951,0,0,0,8.879-1.958h23.4a4.954,4.954,0,0,0,9.818-.939c0-.022,0-.043,0-.064h4.082a1.945,1.945,0,0,0,1.943-1.943v-8.2A2.927,2.927,0,0,0,63.252,137ZM7.117,148.351H4.954a.065.065,0,0,1-.065-.065v-2.072H8.1A4.935,4.935,0,0,0,7.117,148.351Zm4.864,4.015a3.076,3.076,0,0,1-.019-6.152H12a3.076,3.076,0,0,1-.019,6.152Zm8.031,0a3.076,3.076,0,0,1-.019-6.152h.039a3.076,3.076,0,0,1-.019,6.152Zm28.262-4.015h-23.4a4.934,4.934,0,0,0-.984-2.136H42.1a.939.939,0,0,0,0-1.878H1.943a.065.065,0,0,1-.065-.065V122.188a.065.065,0,0,1,.065-.065H48.119a.065.065,0,0,1,.065.065v22.149H46.112a.939.939,0,1,0,0,1.878h3.146A4.934,4.934,0,0,0,48.274,148.351ZM60.2,136.306H54.142a.065.065,0,0,1-.065-.065v-4.08h4.741Zm-7.062,16.061a3.076,3.076,0,0,1-.019-6.152h.026a3.076,3.076,0,0,1-.007,6.152Zm9.1-5.083a.065.065,0,0,1-.065.065H57.7a4.962,4.962,0,0,0-4.557-3.012H50.062V128.211h0a.065.065,0,0,1,.065-.065H57.48l.712,2.137H53.138a.939.939,0,0,0-.939.939v5.019a1.945,1.945,0,0,0,1.943,1.943h7.642l.141.141a1.062,1.062,0,0,1,.313.755v2.245H61.169a.939.939,0,0,0,0,1.878h1.068Z",
    transform: "translate(0 -120.245)",
    fill: "#fff"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56517",
    "data-name": "\\uADF8\\uB8F9 56517",
    transform: "translate(4.015 20.076)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56516",
    "data-name": "\\uADF8\\uB8F9 56516",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33958",
    "data-name": "\\uD328\\uC2A4 33958",
    d: "M73.156,280.567H33a.939.939,0,1,0,0,1.878H73.156a.939.939,0,0,0,0-1.878Z",
    transform: "translate(-32.064 -280.567)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck4);
export default __webpack_public_path__ + "static/media/check4.27f049cccc163d81b382daeb69d89e36.svg";
export { ForwardRef as ReactComponent };